import React from 'react';
import { photos, sampleExercises, sampleMeta } from '../data/content';
import { OfferLink } from './ui/OfferLink';
import { Eyebrow, Mark, SectionTitle } from './ui/Section';
export function LookInside() {
  return <section className="bg-ivory px-4 py-14 md:py-20" data-id="element-119" data-mp="21lzcxpst6azj">
      <div className="mx-auto max-w-6xl" data-id="element-120" data-mp="25om8a0ooue1h">
        <Eyebrow data-id="element-121" data-mp="25nkxzyfhxvkt">Look inside</Eyebrow>
        <SectionTitle data-id="element-122" data-mp="25qp5p5s679g8">
          What you get <Mark data-id="element-123" data-mp="1rwpk27q54oad">inside each class</Mark>
        </SectionTitle>

        <div className="mt-10 grid items-center gap-8 lg:grid-cols-5" data-id="element-124" data-mp="1rv4p4gzwz3bz">
          <OfferLink className="lg:col-span-2" label="See the Complete Stretching System 2026 offer" data-id="element-125" data-mp="1wpinms9vhqkv">
            <img src={photos.coachPlanning} alt="Coach reviewing a structured weekly class plan" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-xl transition-transform duration-300 ease-out group-hover:scale-[1.01] lg:aspect-[4/5]" data-id="element-126" data-mp="1i0mjv7eumzq2" />
          </OfferLink>

          <article className="overflow-hidden rounded-2xl border border-charcoal/10 bg-white shadow-xl lg:col-span-3" data-id="element-127" data-mp="1dz9boqoaakfz">
            <header className="bg-charcoal p-5 md:p-6" data-id="element-128" data-mp="61cn18f7imjr">
              <p className="text-[11px] font-extrabold uppercase tracking-wider text-gold" data-id="element-129" data-mp="60t4pqln9w57">
                Sample class · Week 27 · Class B
              </p>
              <h3 className="mt-1 font-display text-lg font-black uppercase text-ivory md:text-xl" data-id="element-130" data-mp="f1hjiniv40j5">
                Pike Flexibility Progression
              </h3>
            </header>
            <dl className="grid grid-cols-2 gap-px bg-charcoal/10 sm:grid-cols-4" data-id="element-131" data-mp="3iire31ylo07u">
              {sampleMeta.map(([label, value]) => <div key={label} className="bg-white p-4" data-id="element-132" data-mp="12rkv3ge9sso">
                  <dt className="text-[10px] font-extrabold uppercase tracking-wider text-charcoal/55" data-id="element-133" data-mp="3sgxbp7ddik6w">
                    {label}
                  </dt>
                  <dd className="mt-0.5 text-sm font-bold text-charcoal" data-id="element-134" data-mp="34p8fvh1cfdl7">{value}</dd>
                </div>)}
            </dl>
            <div className="overflow-x-auto border-t border-charcoal/10 px-5 py-4 md:px-6" data-id="element-135" data-mp="13p3irrlapwkl">
              <table className="w-full min-w-[460px] text-left text-sm" data-id="element-136" data-mp="18nya5hxbwtgb">
                <thead data-id="element-137" data-mp="18m3mhvuoan8j">
                  <tr className="border-b border-charcoal/10 text-[10px] uppercase tracking-wider text-charcoal/55" data-id="element-138" data-mp="1den18w53joex">
                    <th scope="col" className="pb-2 font-extrabold" data-id="element-139" data-mp="1hgrs5n45u6xv">Exercise</th>
                    <th scope="col" className="pb-2 font-extrabold" data-id="element-140" data-mp="kpze0v0seoyq">Sets / Reps</th>
                    <th scope="col" className="pb-2 font-extrabold" data-id="element-141" data-mp="ksc2zs4ypzla">Hold</th>
                    <th scope="col" className="pb-2 font-extrabold" data-id="element-142" data-mp="pplxvnb4f3gi">Coaching cue</th>
                  </tr>
                </thead>
                <tbody data-id="element-143" data-mp="ypqx3a65uvjl">
                  {sampleExercises.map(([exercise, sets, hold, cue]) => <tr key={exercise} className="border-b border-charcoal/10 last:border-b-0" data-id="element-144" data-mp="255ulvtc2jq8q">
                      <td className="py-2.5 pr-3 font-bold text-charcoal" data-id="element-145" data-mp="2a4xf8gios80v">{exercise}</td>
                      <td className="py-2.5 pr-3 text-charcoal/80" data-id="element-146" data-mp="2a6qnu1cv12bi">{sets}</td>
                      <td className="py-2.5 pr-3 text-charcoal/80" data-id="element-147" data-mp="2k8cekpwdsafk">{hold}</td>
                      <td className="py-2.5 text-charcoal/70" data-id="element-148" data-mp="2fasvncoqn9ha">{cue}</td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </div>
    </section>;
}